import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError(false);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/forgot-password`, // Change if different
        { email }
      );
      setMessage(response.data.message);
      setEmail("");
      setError(false);
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Something went wrong. Try again."
      );
      setError(true);
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f1f1f1",
          padding: 2,
        }}
      >
        <Container maxWidth="sm">
          <Paper elevation={4} sx={{ padding: 4 }}>
            <Typography variant="h5" align="center" gutterBottom>
              Forgot Password
            </Typography>
            <Typography>
              Enter the email address associated with your account and we will
              send you a link to reset your password.
            </Typography>
            {message && (
              <Alert severity={error ? "error" : "success"} sx={{ mb: 2 }}>
                {message}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="normal"
                placeholder="Enter email "
                required
              />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
              >
                Continue
              </Button>

              <Box sx={{ mt: 2 }}>
                <Link to="/login">
                  <Typography
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Back to Login
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default ForgotPassword;
